import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Hero from '../features/hero';
import Sections from '../features/sections';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { PageProps } from 'gatsby';

function IndexPageDesktop() {
  return (
    <>
      <Hero.desktop />
      <Sections.desktop />
    </>
  );
}

function IndexPageMobile() {
  return (
    <>
      <Hero.mobile />
      <Sections.mobile />
    </>
  );
}

const IndexPage:React.FC<PageProps> = ({location}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Layout>
      <SEO
        location={location}
        keywords={[
          `affordable`,
          `cheap`,
          `remote`,
          `personal trainer`,
          `fitness trainer`,
          `fitness coach`,
          `train over messenger`,
          `cheap personal trainer`,
          `fitness coach`,
          `custom workout plans`,
          `habfit`,
          `HabFit`,
        ]}
        title="Main"
      />

      <section className="w-full relative">
        {isDesktop ? <IndexPageDesktop /> : <IndexPageMobile />}
      </section>
    </Layout>
  );
}

export default IndexPage;
